
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

export const notifysuccess = (message) =>{
    toast.success(message,{
        position:toast.POSITION.TOP_RIGHT,
   autoClose:1500
    })
}

export const notifyerror = (message) =>{
    toast.error(message,{
        position:toast.POSITION.TOP_RIGHT,
        autoClose:1000
    })
}

export const notifyinfo = (message)=>{
    toast.info(message,{
        position:toast.POSITION.TOP_RIGHT,
        autoClose:1000,

    })
}
